export default __webpack_public_path__ + "static/media/plugNegative.f4e8c5df.svg";